import PricingHeader from "../../components/Layouts/PricingHeader";
import Header from "../../components/Layouts/Header";
import Payment from "../../components/BuyCredit/Payment";
import BottomBar from "../../components/Layouts/BottomBar";
import PricingFooter from "../../components/Layouts/PricingFooter";
import "./Credit.css";

const CreditPayment = () => {
  return (
    <>
      <div className="billing_page_layout">
        <Header />
        <Payment />
        <BottomBar className="bottom-bar-spacing" />
        <PricingFooter />
      </div>
    </>
  );
};

export default CreditPayment;
